import {
  GavelIcon,
  HandshakeIcon,
  UsersIcon,
  ScaleIcon,
} from 'lucide-react'
import type { SkillGroup } from '../types/profile'

export const skillGroups: SkillGroup[] = [
  {
    group: 'Chairing & Meeting Craft',
    icon: GavelIcon,
    skills: [
      {
        name: 'Chairing a unitary board',
        level: 97,
        note: 'Agenda control, airtime discipline, decision capture',
      },
      {
        name: 'Committee leadership',
        level: 95,
        note: 'Audit & Risk, Remuneration, Employee Benefit Trust',
      },
      {
        name: 'Constructive challenge of executives',
        level: 94,
        note: 'Support and scrutiny held in balance',
      },
    ],
  },
  {
    group: 'Stakeholder Negotiation',
    icon: HandshakeIcon,
    skills: [
      {
        name: 'Ministerial & Whitehall engagement',
        level: 98,
        note: 'Fluent in the machinery of government',
      },
      {
        name: 'Union & workforce negotiation',
        level: 92,
        note: 'Tripartite bargaining and change consultation',
      },
      {
        name: 'Investor & owner relations',
        level: 88,
        note: 'Private equity, trusts and state ownership',
      },
    ],
  },
  {
    group: 'People & Succession',
    icon: UsersIcon,
    skills: [
      {
        name: 'CEO appointment & onboarding',
        level: 95,
        note: 'Two chief executive transitions led',
      },
      {
        name: 'Executive reward design',
        level: 90,
        note: 'Remuneration policy and long-term incentives',
      },
      {
        name: 'Board composition & evaluation',
        level: 89,
        note: 'Skills mapping, refreshment and effectiveness review',
      },
    ],
  },
  {
    group: 'Judgement Under Pressure',
    icon: ScaleIcon,
    skills: [
      {
        name: 'Change-of-control decision making',
        level: 96,
        note: 'Steady hand through ownership transition',
      },
      {
        name: 'Risk appetite & assurance',
        level: 93,
        note: 'Three lines of defence, control environment',
      },
      {
        name: 'Crisis and contingency leadership',
        level: 90,
        note: 'Calm sequencing when timelines compress',
      },
    ],
  },
]
